import axios from "axios";

import {
  GetProgramTicketDetailsRequest,
  GetProgramTicketDetailsResponse,
  GetProgramTicketsRequest,
  GetProgramTicketsResponse,
} from "./types";

const PROGRAM_TICKETS_URL = "/tickets";
const PROGRAM_TICKET_DETAILS_URL = "/tickets/details";

export interface PostProgramTicketsResult {
  readonly status: number;
  readonly response: GetProgramTicketsResponse;
  readonly etag: string | undefined;
}

export interface PostProgramTicketsOptions {
  readonly signal?: AbortSignal;
  readonly ifNoneMatch?: string;
}

function extractEtag(
  headers: Record<string, unknown> | undefined
): string | undefined {
  if (!headers) return undefined;
  const raw = headers["etag"] ?? headers["ETag"];
  return typeof raw === "string" ? raw : undefined;
}

export async function postProgramTickets(
  body: GetProgramTicketsRequest,
  options: PostProgramTicketsOptions = {}
): Promise<PostProgramTicketsResult> {
  const headers: Record<string, string> = {};
  if (options.ifNoneMatch !== undefined) {
    headers["If-None-Match"] = options.ifNoneMatch;
  }
  const {
    data,
    status,
    headers: responseHeaders,
  } = await axios.post<GetProgramTicketsResponse>(PROGRAM_TICKETS_URL, body, {
    signal: options.signal,
    headers,
    validateStatus: (s) => (s >= 200 && s < 300) || s === 304,
  });
  const etag = extractEtag(responseHeaders as Record<string, unknown>);
  if (status === 304) {
    return { status, response: { tickets: [], totalCount: 0 }, etag };
  }
  return { status, response: data, etag };
}

export interface PostProgramTicketDetailsOptions {
  readonly signal?: AbortSignal;
}

export async function postProgramTicketDetails(
  body: GetProgramTicketDetailsRequest,
  options: PostProgramTicketDetailsOptions = {}
): Promise<GetProgramTicketDetailsResponse> {
  const { data } = await axios.post<GetProgramTicketDetailsResponse>(
    PROGRAM_TICKET_DETAILS_URL,
    body,
    { signal: options.signal }
  );
  return data;
}
